import { httpsCallable } from 'firebase/functions';
import { functions } from '../utils/firebase';

/**
 * Get the current launch status for a game
 * @param {string} gameId - The game ID to check
 * @returns {Promise<{ok: boolean, status: string, session?: object}>}
 */
export async function getLaunchStatus(gameId) {
  try {
    const getLaunchStatusFn = httpsCallable(functions, 'getLaunchStatus');
    const result = await getLaunchStatusFn({ gameId });
    return result.data;
  } catch (error) {
    console.error('Error getting launch status:', error);
    throw error;
  }
}

/**
 * Start a new launch session for a game
 * @param {string} gameId - The game ID to start a session for
 * @returns {Promise<{ok: boolean, sessionId: string, startedAt: number, expiresAt: number, isNewSession: boolean}>}
 */
export async function startLaunchSession(gameId) {
  try {
    const startLaunchSessionFn = httpsCallable(functions, 'startLaunchSession');
    const result = await startLaunchSessionFn({ gameId });
    return result.data;
  } catch (error) {
    console.error('Error starting launch session:', error);
    throw error;
  }
}

/**
 * Create $10 overage checkout session for subscription users
 * @param {string} gameId - The game ID to create overage checkout for
 * @returns {Promise<{ok: boolean, checkoutUrl: string, sessionId: string}>}
 */
export async function createOverageCheckout(gameId) {
  try {
    const createOverageCheckoutFn = httpsCallable(functions, 'createOverageCheckout');
    const result = await createOverageCheckoutFn({ gameId });
    return result.data;
  } catch (error) {
    console.error('Error creating overage checkout:', error);
    throw error;
  }
}

/**
 * Run the migration to backfill sessions (admin only)
 * @returns {Promise<{success: boolean, message: string, migratedSessions: number, cleanedUsers: number}>}
 */
export async function backfillSessions() {
  try {
    const backfillSessionsFn = httpsCallable(functions, 'backfillSessions');
    const result = await backfillSessionsFn();
    return result.data;
  } catch (error) {
    console.error('Error running migration:', error);
    throw error;
  }
}
